/**
 * AllToursPage — standalone, bookmarkable `/tours` page that wraps the
 * shared `AllToursCatalog` with a header so admins can land here
 * directly (e.g. via the welcome-prompt's "View all tours" link or by
 * sharing the URL with a teammate).
 */
import { Link } from "react-router-dom";
import { ArrowLeft, BookOpen } from "@phosphor-icons/react";
import AllToursCatalog from "@/components/AllToursCatalog";

export default function AllToursPage({ user }) {
  return (
    <div className="min-h-screen bg-slate-50">
      <header className="bg-white border-b border-slate-200 px-4 sm:px-6 py-3 sticky top-0 z-10"
              data-testid="all-tours-page-header">
        <div className="max-w-3xl mx-auto flex items-center gap-3">
          <Link to="/" data-testid="all-tours-back" className="text-slate-500 hover:text-slate-800">
            <ArrowLeft size={18} />
          </Link>
          <BookOpen size={16} weight="bold" className="text-blue-700" />
          <h1 className="text-sm font-bold font-['Chivo'] tracking-tight">All interactive tours</h1>
          <div className="ml-auto text-xs text-slate-500 truncate max-w-[220px]">{user?.email || "Guest"}</div>
        </div>
      </header>

      <main className="max-w-3xl mx-auto p-4 sm:p-6 space-y-5">
        <section className="bg-white border border-slate-200 rounded-md p-5">
          <h2 className="text-sm font-bold text-slate-800 mb-1">Onboarding catalog</h2>
          <p className="text-xs text-slate-500 mb-4">
            Each tour highlights one of the heavier admin pages. Click "Watch" to jump there
            and start the spotlight walkthrough.
          </p>
          <AllToursCatalog user={user} />
        </section>
      </main>
    </div>
  );
}
